$(document).ready(function() {

	// *************************************************************************
	// Local scroll
	// *************************************************************************

	$.localScroll({ duration: 1000 });


	// *************************************************************************
	// Timeliner
	// *************************************************************************

	$(".timeliner").timeliner({
		scrollTo: 0
	});
	$(".timeliner-prev").click(function(event) {
		event.preventDefault();
		$(".timeliner").timeliner("prev");
		$(window).scrollTo(".timeliner-content", 1000);
	});
	$(".timeliner-next").click(function(event) {
		event.preventDefault();
		$(".timeliner").timeliner("next");
		$(window).scrollTo(".timeliner-content", 1000);
	});


	// *************************************************************************
	// Sliders - gallery
	// *************************************************************************

	$(".inline-gallery").slickExt({
		// centerMode: true,
		// variableWidth: true
	});

	$(".two-row-gallery").slickExt({
		slidesToShow: 5,
		rows: 2,
	});


	// *************************************************************************
	// Fancybox binder (in history)
	// *************************************************************************

	$("[data-bind-fancybox]").click(function(event) {
		event.preventDefault();
		var fancyboxId = $(this).data("bindFancybox");
		var href = $(this).attr("href");
		var $fancyboxElement = $("[data-fancybox='" + fancyboxId + "'][href='" + href + "']");
		var fancyboxIndex = $fancyboxElement.index();

		if ($fancyboxElement.hasClass("slick-slide")) {
			$fancyboxElement.closest(".slick-slider").slick("slickGoTo", fancyboxIndex);
		}

		$.fancybox.open($("[data-fancybox='" + fancyboxId + "']"), {}, fancyboxIndex);
	});


	// *************************************************************************
	// Ajax Form
	// *************************************************************************

	$.ajaxForm();


	// *************************************************************************
	// Animation on homepage
	// *************************************************************************

	$(".page-header-curtain").curtain();
	$(".parallax").scrollAnimation();

});
